import React, { useEffect, useState } from 'react'
import ClientCompanyTypeModel from './models/ClientEnvironmentModel';

function ViewClientEnvironment(props) {
  const [clientCompanyTypeData, setUserData] = useState(new ClientCompanyTypeModel());

  useEffect(() => {
    setUserData(props.ClientCompanyTypeData);
  }, [props.ClientCompanyTypeData])
  return (
    <>
      <div className="row">
        <div className="mb-3 add-product">
          <label className="form-label">Client Company Type Name</label>
          <input type="text" className="form-control" value={clientCompanyTypeData.ClientCompanyTypeName} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Description</label>
          <textarea className="form-control h-100" rows="5" value={clientCompanyTypeData.Description} disabled />
        </div>
      </div>
    </>
  )
}

export default ViewClientEnvironment